import PtBRInternationalMetricDesktop from 'src/images/SVG/field-of-play/pt-BR/international-metric-desktop.svg'
import PtBRInternationalMetricMobile from 'src/images/SVG/field-of-play/pt-BR/international-metric-mobile.svg'
import PtBRInternationalYardsMobile from 'src/images/SVG/field-of-play/pt-BR/international-yards-mobile.svg'
import PtBRInternationalYardsDesktop from 'src/images/SVG/field-of-play/pt-BR/international-yards-desktop.svg'
import PtBRNationalMetricDesktop from 'src/images/SVG/field-of-play/pt-BR/national-metric-desktop.svg'
import PtBRNationalMetricMobile from 'src/images/SVG/field-of-play/pt-BR/national-metric-mobile.svg'
import PtBRNationalYardsDesktop from 'src/images/SVG/field-of-play/pt-BR/national-yards-desktop.svg'
import PtBRNationalYardsMobile from 'src/images/SVG/field-of-play/pt-BR/national-yards-mobile.svg'

interface InteractiveImage {
  isNational: boolean
  isMetric: boolean
  isMobile: boolean
  image: string
  language: string
}

const images: Array<InteractiveImage> = [
  {
    isNational: false,
    isMetric: true,
    isMobile: false,
    image: PtBRInternationalMetricDesktop,
    language: 'pt-BR',
  },
  {
    isNational: false,
    isMetric: true,
    isMobile: true,
    image: PtBRInternationalMetricMobile,
    language: 'pt-BR',
  },
  {
    isNational: false,
    isMetric: false,
    isMobile: true,
    image: PtBRInternationalYardsMobile,
    language: 'pt-BR',
  },
  {
    isNational: false,
    isMetric: false,
    isMobile: false,
    image: PtBRInternationalYardsDesktop,
    language: 'pt-BR',
  },
  {
    isNational: true,
    isMetric: true,
    isMobile: false,
    image: PtBRNationalMetricDesktop,
    language: 'pt-BR',
  },
  {
    isNational: true,
    isMetric: true,
    isMobile: true,
    image: PtBRNationalMetricMobile,
    language: 'pt-BR',
  },
  {
    isNational: true,
    isMetric: false,
    isMobile: false,
    image: PtBRNationalYardsDesktop,
    language: 'pt-BR',
  },
  {
    isNational: true,
    isMetric: false,
    isMobile: true,
    image: PtBRNationalYardsMobile,
    language: 'pt-BR',
  },
]

export default images
